import ApprovedRiders from './ApprovedRiders';
export default ApprovedRiders;
